import React from "react";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Box } from "@mui/material";

export default function SaitCheckboxColumn(config) {
	return {
		headerName: config.header,
		field: config.field,
		width: config.width || 45,
		sortable: false,
		disableColumnMenu: true,
		hidden: config.hidden || false,
		actionColumn: true,
		rifValue: config.rifValue,
		display: "flex",
		objmod: config.objmod,
		renderCell: (params) => {
			if (params.value) {
				if (params.value === "Y") {
					return (
						<Box
							sx={{
								flexGrow: 1,
								display: "inline-flex",
								justifyContent: "center",
							}}
						>
							<CheckIcon color="success" type="CheckIcon" />
						</Box>
					);
				} else if (!config.checkOnly) {
					return (
						<Box
							sx={{
								flexGrow: 1,
								display: "inline-flex",
								justifyContent: "center",
							}}
						>
							<CloseIcon color="error" type="CloseIcon" />
						</Box>
					);
				} else {
					return null;
				}
			}
		},
	};
}
